<template>
    <transition
        :css="false"
        @appear="intro"
        @enter="intro"
        @leave="outro"
    >
        <section class="ChapterArt">
            <div class="ChapterArt-container" ref="container">
                <div class="ChapterArt-stage" :style="stageStyle">
                    <animated-sprite
                        v-show="visible && loaded"
                        :frames="images"
                        :start="0"
                        :end="images.length - 1"
                        :fps="15"
                        @complete="onPlayerComplete"
                    ></animated-sprite>
                    <carousel
                        class="ChapterArt-carousel"
                        v-show="carouselVisible"
                        :images-src="activeChapterArtwork"
                        :active-item="activeItem"
                        :outro-disabled="true"
                    ></carousel>
                </div>
            </div>
            <nav-ctrls
                class="ChapterArt-ctrls"
                :disable-back="disableBack"
                :disable-next="disableNext"
                @back="back"
                @next="next"
            ></nav-ctrls>
            <nav-indicators
                :total="activeChapterArtwork.length"
                :active-item="activeItem"
            ></nav-indicators>
            <close-link :to="closeTo"></close-link>
            <div class="ChapterArt-heading">
                <img
                    class="ChapterArt-logo"
                    src="~assets/img/logo.png"
                    alt="Moleskine"
                >
                <h1 class="ChapterArt-title">
                    {{ title }}
                </h1>
            </div>
            <div class="ChapterArt-share">
                <social-share
                    :url="shareUrl"
                ></social-share>
            </div>
        </section>
    </transition>
</template>

<script>
    import {fill} from 'lodash'
    import {getContainRect} from '@/app/utils/backgroundUtils'
    import * as routes from '@/app/routes'
    import app from '@/app'
    import ChapterUtils from '@/app/mixins/ChapterUtils'
    import Loader from '@/app/utils/pixi/Loader'
    import AnimatedSprite from '@/app/components/AnimatedSprite'
    import CloseLink from '@/app/components/CloseLink'
    import SocialShare from '@/app/components/SocialShare'
    import Carousel from '@/app/components/Carousel'
    import NavCtrls from '@/app/components/NavCtrls'
    import NavIndicators from '@/app/components/NavIndicators'
    import TextTransition from "@/app/transitions/TextTransition"

    export default {
        name: 'ChapterArt',
        mixins: [
            ChapterUtils,
        ],
        components: {
            AnimatedSprite,
            CloseLink,
            SocialShare,
            Carousel,
            NavCtrls,
            NavIndicators,
            TextTransition
        },
        data: () => ({
            loader: null,
            loaded: false,
            visible: false,
            carouselVisible: false,
            activeItem: 0,
            playerRect: {
                width: 0,
                height: 0,
                top: 0,
                left: 0,
            },
        }),
        async mounted() {
            this.setLoader()
            await this.load()
        },
        methods: {
            intro(el, done) {
                this.setBackgroundVisible(false);
                // Reset visible colaboration
                this.activeItem = 0
                // Set player size as "contain"
                this.setPlayerRect()
                app.resize.add(this.setPlayerRect)
                // Delay notebook sequence start
                TweenLite.delayedCall(1, () => {
                    this.visible = true
                })
                // Anim this view intro
                TweenLite.fromTo(el, 2, {
                    alpha: 0,
                }, {
                    alpha: 1,
                    onComplete: done,
                })
            },
            outro(el, done) {
                this.setBackgroundVisible(true);
                app.resize.remove(this.setPlayerRect)
                TweenLite.to(el, 1, {
                    alpha: 0,
                    onComplete: () => {
                        this.visible = false
                        this.carouselVisible = false
                        done()
                    },
                    ease: Cubic.easeOut,
                })
            },
            setLoader() {
                const {images} = this
                this.loader = new Loader({
                    assets: images,
                })
            },
            setPlayerRect() {
                const {$refs} = this
                const rect = getContainRect(
                    1440,
                    1209,
                    $refs.container.offsetWidth,
                    $refs.container.offsetHeight
                )
                this.$set(this, 'playerRect', rect)
            },
            async load() {
                const {loader} = this
                await loader.load()
                this.loaded = true
            },
            onPlayerComplete() {
                // Show collaborations
                this.carouselVisible = true
            },
            back() {
                this.activeItem -= 1
            },
            next() {
                this.activeItem += 1
            },
        },
        computed: {
            images() {
                const {$store} = this
                const directory = `${$store.getters.public}/img/notebook-sequence/`
                return fill(Array(24), '')
                    .map((str, i) => {
                        const index = `${i + 1}`.padStart(2, '0')
                        return `${directory}${index}.png`
                    })
            },
            stageStyle() {
                const {playerRect} = this
                return {
                    width: `${playerRect.width}px`,
                    height: `${playerRect.height}px`,
                    top: `${playerRect.top}px`,
                    left: `${playerRect.left}px`,
                }
            },
            closeTo() {
                return {
                    name: routes.CHAPTER,
                }
            },
            title() {
                const {activeChapter, activeChapterIndex} = this
                const index = `${activeChapterIndex + 1}`.padStart(2, '0')
                return `${index} - ${activeChapter.name}`
            },
            shareUrl() {
                return location.href
            },
            disableBack() {
                const {activeItem} = this
                return activeItem === 0
            },
            disableNext() {
                const {activeItem, activeChapterArtwork} = this
                return activeItem === activeChapterArtwork.length - 1
            },
        }
    }
</script>

<style src="styles/views/ChapterArt.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/views/ChapterArt.vue